import { render, staticRenderFns } from "./ResendActivationCodeDialog.vue?vue&type=template&id=21479546&"
import script from "./ResendActivationCodeDialog.vue?vue&type=script&lang=js&"
export * from "./ResendActivationCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports